var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 18.847,
    viewBox: "0 0 20 18.847",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "download-white",
    transform: "translate(-2 -3.153)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83759",
    "data-name": "Path 83759",
    d: "M12,19.847V8",
    transform: "translate(0 -3.847)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83760",
    "data-name": "Path 83760",
    d: "M9,13l2.913,2.913h0a.123.123,0,0,0,.174,0h0L15,13",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83761",
    "data-name": "Path 83761",
    d: "M3,15v4a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2V15",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadWhiteIcon);
export default __webpack_public_path__ + "static/media/download-white-icon.aea1fc59fbdd051629e6b32ac4c7d7f6.svg";
export { ForwardRef as ReactComponent };